import { z } from 'zod';

import { CashDenominationRowsSchema } from './cash-denominations.schema.js';
import { CashExpenseDtoSchema, CashExpenseSourceTypeSchema } from './cash-expenses.schema.js';
import { CashOperationIdentityDtoSchema } from './cash-operation-identity.schema.js';
import {
  type CashExpenseMetadataCorrectionDto,
  type CashExpenseMetadataSnapshotDto,
  type CorrectCashExpenseMetadataRequest,
  type CorrectCashExpenseMetadataResponse,
  type ReplaceCashExpenseRequest,
  type ReplaceCashExpenseResponse,
} from './cash-expense-corrections.dto.js';

const timestampSchema = z.iso.datetime();

export const CashExpenseMetadataSnapshotDtoSchema: z.ZodType<CashExpenseMetadataSnapshotDto> =
  z.object({
    description: z.string().trim().min(1).max(500),
    categoryId: z.uuid().nullable(),
  });

export const CashExpenseMetadataCorrectionDtoSchema: z.ZodType<CashExpenseMetadataCorrectionDto> =
  CashOperationIdentityDtoSchema.extend({
    id: z.uuid(),
    expenseId: z.uuid(),
    prior: CashExpenseMetadataSnapshotDtoSchema,
    current: CashExpenseMetadataSnapshotDtoSchema,
    reason: z.string().trim().min(1).max(500),
    createdAt: timestampSchema,
  });

export const CorrectCashExpenseMetadataRequestSchema: z.ZodType<CorrectCashExpenseMetadataRequest> =
  z.object({
    companyId: z.uuid(),
    operationId: z.uuid(),
    expenseId: z.uuid(),
    description: z.string().trim().min(1).max(500),
    categoryId: z.uuid().nullable().optional(),
    reason: z.string().trim().min(1).max(500),
    occurredAt: timestampSchema.optional(),
  });

export const CorrectCashExpenseMetadataResponseSchema: z.ZodType<CorrectCashExpenseMetadataResponse> =
  z.object({
    cashExpense: CashExpenseDtoSchema,
    correction: CashExpenseMetadataCorrectionDtoSchema,
  });

export const ReplaceCashExpenseRequestSchema: z.ZodType<ReplaceCashExpenseRequest> = z.object({
  companyId: z.uuid(),
  operationId: z.uuid(),
  expenseId: z.uuid(),
  sourceType: CashExpenseSourceTypeSchema,
  storeId: z.uuid().nullable().optional(),
  locationId: z.uuid().nullable().optional(),
  stationId: z.uuid().nullable().optional(),
  cashLocationId: z.uuid(),
  cashSessionId: z.uuid().nullable().optional(),
  categoryId: z.uuid().nullable().optional(),
  amountMinor: z.number().int().positive(),
  description: z.string().trim().min(1).max(500),
  voidReason: z.string().trim().min(1).max(500),
  denominations: CashDenominationRowsSchema.nullable().optional(),
  occurredAt: timestampSchema.optional(),
});

export const ReplaceCashExpenseResponseSchema: z.ZodType<ReplaceCashExpenseResponse> = z.object({
  originalExpense: CashExpenseDtoSchema,
  replacementExpense: CashExpenseDtoSchema,
});
